import React from 'react';
import { motion } from 'framer-motion';
type MeterBarProps = {
  label: string;
  value: number;
  max?: number;
  suffix?: string;
  delay?: number;
  strong?: boolean;
};

/** Labelled horizontal bar used across the insights views. */
export function MeterBar({
  label,
  value,
  max = 100,
  suffix = '%',
  delay = 0,
  strong = false
}: MeterBarProps) {
  return <div data-id="element-76" data-mp="2oir7066vs105">
      <div className="flex items-baseline justify-between gap-3 text-[clamp(0.72rem,0.9vw,0.85rem)]" data-id="element-77" data-mp="2oj0vfpca203q">
        <span className="truncate font-medium text-[var(--fg)]" data-id="element-78" data-mp="2kgw3cv1h9bj7">{label}</span>
        <span className="font-bold tabular-nums text-[var(--fg)]" data-id="element-79" data-mp="2fn1mdzd9bant">
          {value}
          {suffix}
        </span>
      </div>
      <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-[var(--fg)]/[0.07]" data-id="element-80" data-mp="25q6pfkwmtibn">
        <motion.div className={`h-full rounded-full ${strong ? 'bg-[var(--brand)]' : 'bg-[var(--brand-light)]'}`} initial={{
        width: 0
      }} animate={{
        width: `${value / max * 100}%`
      }} transition={{
        delay,
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-81" data-mp="25oc8ehoheacu" />
      </div>
    </div>;
}